<template>
  <div>
    <div v-if="texttitlelist" class="titles">填报期次{{texttitlelist.startday | statusFillingperiod}}({{texttitlelist.startday | tiemfolters}} - {{texttitlelist.endday | tiemfolters}})</div>

    <el-table
      :data="tableData"
      row-key="id"
      default-expand-all
      :tree-props="{children: 'children' }"
      border
      :summary-method="getTotal"
      :show-summary="Calculate"
      style="width: 100%"
      :row-class-name="rowClassName"
      :header-cell-style="getRowClass"
      :cell-style="$route.path == '/AppealAnalysis' ? TableRowStyle : {}"
    >
      <el-table-column
        v-for="(item, index) in tableLabel"
        :key="index"
        :prop="item.prop"
        :width="item.width"
        :label="item.ifshow ? '' : item.label"
        :align="item.align"
        show-overflow-tooltip
        :type="item.type"
      >
        <template slot-scope="scope" v-if="item.ifshow ? '' : item.label ">
          <!-- 操作按钮处理
          Booele
          ifshow：判断哪些字段导出时需要隐藏
          isOpera:是否生成按钮
          isbutton：是否可以根据不同状态去切换按钮
          controldisabled: 给需要改变状态的按钮加上可以操作该按钮状态
          -->
            <template v-if="item.isOpera" >
              <template v-if="item.isbutton">
                    <el-button
                      class="nav-main3_buotton"
                      @click="handleGoods(DateTitle(scope.row.status,items,item.titleList) , scope.row)"
                      :plain="true"
                      v-for="(items,index) in item.titleList"
                      :key="index"
                      :type="items.status"
                      :size="'mini'"
                      :disabled='scope.row.parentId !== "0" && items.controldisabled'
                    >{{items.title}}</el-button>
              </template>
               <template v-else>
                    <el-button
                      class="nav-main3_buotton"
                      @click="handleGoods(items.title, scope.row)"
                      :plain="true"
                      v-for="(items,index) in item.titleList"
                      :key="index"
                      :type="items.status"
                      :size="'mini'"
                      :disabled='false'
                    >{{items.title}}</el-button>
              </template>
            </template>
            <!-- 表格数据处理 isStatus：根据状态去显示不同的文本数据 textStatus：是否可以点击文本内容  -->
            <template v-else>
            <!-- 当字段不存在时 默认为暂无 格式化字段-->
                <template v-if="scope.row[item.prop] || scope.row[item.prop] == 0">
                  <template v-if="item.prop == 'executeRegion'">
                      {{$Implementation.value(scope.row[item.prop],'msg')}}
                  </template>
                   <template v-else-if="item.prop == 'gmtCreate'">
                      {{scope.row[item.prop] | tiemfolterday}}
                  </template>
                  <template v-else-if="item.prop == 'appealType'">
                    <!-- {{scope.row[item.prop]}} -->
                       {{$AppealType.value(scope.row[item.prop],'name')}}
                  </template>
                  <!-- <template v-else-if="item.prop == 'modelId'">
                       {{$Subsystem.value(scope.row[item.prop],'name')}}
                  </template> -->
                  <template v-else-if="item.prop == 'appealStatus'">
                       {{scope.row[item.prop] | StatusAppealStatus($Routers().districtIdsNum)}}
                  </template>
                  <template v-else-if="item.prop == 'type'">
                       {{constraintType(scope.row[item.prop])}}
                  </template>
                   <template v-else-if="item.prop == 'TREND' || item.prop == 'TREND2'">
                       {{scope.row[item.prop] | statusCalculate}}
                  </template>
                  <template v-else>
                      {{ scope.row[item.prop] }}
                  </template>
                </template>
                <template v-else>
                      --
                </template>
            </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dateUtils from '@/utils/dateUtils'
import apiRule from '@/utils/apiRule'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableLabel: {
      type: Array,
      default: () => {
        return []
      }
    },
    ifheader: {
      type: Boolean,
      default: false
    },
    Calculate: {
      type: Boolean,
      default: false
    },
    texttitle: {
      type: Boolean,
      default: false
    },
    texttitlelist: {
      type: Object
    },
    ifshow: {
      type: Boolean
    }
  },
  data () {
    return {
      list: [],
      that: this,
      apiRuleObj: { key: 'value' }
    }
  },
  created () {
    console.log(this.apiRuleObj)
    // eslint-disable-next-line no-return-assign
    apiRule.apiRuleTypeObj(obj => this.apiRuleObj = obj)
  },
  filters: {
    // 标题时间
    tiemfolters (value) {
      return dateUtils.dateFormat('YYYY.mm.dd', new Date(value))
    },
    // 精确到 月时间
    tiemfoltermonth (value) {
      return dateUtils.dateFormat('YYYY-mm', new Date(value))
    },
    // 精确到日时间
    tiemfolterday (value) {
      return dateUtils.dateFormat('YYYY-mm-dd', new Date(value))
    },
    // 按钮多状态文本标题显示
    IsbuttonType (value, status, jurisdiction) {
      if (jurisdiction === 3) {
        if (value instanceof Array) {
          if (status === 1) {
            return value[0].label
          } else {
            return value[1].label
          }
        } else {
          return value
        }
      } else if (jurisdiction === 2) {
        return value
      } else if (jurisdiction === 1) {
        return value
      }
    },
    // 企业 3
    // 0 未提交 查看 修改 提交 删除     提交
    // 1 待受理 查看                   撤回
    // 2 处理中 查看
    // 3 已反馈 查看
    // 区级 2
    // 1 待处理 查看 处理反馈 推送市级
    // 2 处理中 查看
    // 3 已反馈 查看
    // 市级 1
    // 1 待处理 查看 处理反馈
    // 2 处理中 查看
    // 3 已反馈 查看
    // 状态按钮变化处理
    IsbuttonTypes (status, value, jurisdiction) {
      if (jurisdiction === 3) {
        if (value.title instanceof Array) {
          if (status === 2 || status === 3) {
            if (value.title === '查看') {
              return false
            }
            return true
          }
        } else {
          if (status === 0) {
            return false
          } else if (status === 1 || status === 2 || status === 3) {
            if (value.title === '查看') {
              return false
            }
            return true
          }
        }
      } else if (jurisdiction === 2) {
        if (status === 1) {
          return false
        } else if (status === 2 || status === 3) {
          if (value.title === '查看') {
            return false
          }
          return true
        }
      } else if (jurisdiction === 1) {
        if (status === 3) {
          if (value.title === '查看') {
            return false
          }
          return true
        }
      }
    },
    // 反馈状态
    StatusAppealStatus (value, jurisdiction) {
      var data = ''
      switch (value) {
        case 0: data = '未提交'
          break
        case 1: data = jurisdiction === 3 ? '待受理' : '待处理'
          break
        case 2: data = jurisdiction === 1 ? '待处理' : '处理中'
          break
        case 3: data = '已反馈'
          break
        default:
          break
      }
      return data
    },
    // 统计保留两位小数
    statusCalculate (value, a) {
      // if(!isNaN(Number(value)) && a !== 'index'){
      return parseFloat(value).toFixed(2)
      // }else{
      // }
    }

  },
  methods: {
    DateTitle (status, value, titleList) {
      if (value.title instanceof Array) {
        if (status === 1) {
          return value.title[0].label
        } else {
          return value.title[1].label
        }
      } else {
        return value.title
      }
    },
    // 约束类型
    constraintType (value) {
      return `${value}（${this.apiRuleObj[value]}）`
    },
    // 合计
    getTotal (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              // return Number(prev + curr).toFixed(2);
              return (Number(prev) + Number(curr)).toFixed(1)
            } else {
              return prev
            }
          }, 0)
          // eslint-disable-next-line no-unused-expressions
          sums[index]
        } else {
          sums[index] = '--'
        }
      })
      return sums
    },
    // 序号
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex + 1
    },
    getRowClass ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex >= 7 && this.ifheader) {
        return 'background:#FFF0D9'
      } else {
        return 'background:#EEF9FD'
      }
    },
    handleGoods (type, row) {
      this.$emit('event-button', type, row)
    },
    formatters (row, column, cellValue, index) {
    },
    // 改变指定列的背景色
    TableRowStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3 || columnIndex === 4) { // 第三第四列的背景色就改变了2和3都是列数的下标
        return 'background:#FDF6EC'
      }
      if (columnIndex === 5 || columnIndex === 6 || columnIndex === 7) { // 第三第四列的背景色就改变了2和3都是列数的下标
        return 'background:#F4F4F5'
      }
    }
    //
  }
}
</script>

<style lang="scss" scoped>
// 待审核 0
.statustitletruesclass {
  color: #c0b410;
}
// 已通过 1
.statustitletrueclass {
  color: #77C94F;
}
// 未通过 2
.statustitlefalseclass {
  color: #909399;
}
</style>
<style  lang="scss">
  /* /deep/ 为深度操作符，可以穿透到子组件 */
 .el-table {
  display: flex;
  flex-direction: column;
}

/* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
.el-table__body-wrapper {
  order: 1;
}
.titles{
  height: 40px;
  font-size: 20px;
  color: #909399;
}
</style>
